// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3OEHs","row":"ProcedureTreatmentSummary_row__2EvVP"};